package kz.dentalcrm.app.theme

import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.receiveAsFlow

data class SnackbarEvent(
    val message: String,
    val snackbarType: SnackbarType = SnackbarType.Green,
    val action: SnackbarAction? = null
) {
    sealed interface SnackbarType {
        data object Red: SnackbarType
        data object Green : SnackbarType
        data object Grey : SnackbarType
    }
}

data class SnackbarAction(
    val name: String,
    val action: suspend () -> Unit
)

object SnackbarController {

    private val _events = Channel<SnackbarEvent>()
    val events = _events.receiveAsFlow()

    suspend fun sendEvent(event: SnackbarEvent) {
        _events.send(event)
    }
}